import routerOptions0 from "/usr/src/app/content/n3-spas-ba766141-1247-43c3-bc18-f0172cd05d6e/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}